export default "__VITE_ASSET__R37Dlnfq__"